// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_3mbvi","title":"index_title_3YaON","star":"index_star_3caUc"};